import Long from "long";
import _m0 from "protobufjs/minimal";
export const protobufPackage = "snapchat.content";
export interface Asset {
    id: string;
    type: Asset_AssetType;
}
export enum Asset_AssetType {
    UNSET = 0,
    BLOOPS_STICKER = 1,
    MUSIC = 2,
    RAW_MEDIA = 3,
    CANVAS_STICKER = 4,
    BASE_MEDIA = 5,
    OVERLAY = 6,
    EDITS = 7,
    FIRST_FRAME = 8,
    THUMBNAIL = 9,
    CAMEO = 10,
    WEB_THUMBNAIL = 11,
    WEB_MEDIA = 12,
    LENS_ASSET = 13,
    VOICEOVER = 14,
    AVATAR_IMAGE = 15,
    SPECTACLES_SIXDOF = 16,
    PLAIN_MEDIA = 17,
    LENS_MEDIA = 18,
    LOCAL_BURN_IN_ASSET = 19,
    CAMERA_ROLL_INDEX = 20,
    UNRECOGNIZED = -1
}
function createBaseAsset(): Asset {
    return { id: "", type: 0 };
}
export const Asset = {
    encode(message: Asset, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.type !== 0) {
            writer.uint32(16).int32(message.type);
        }
        return writer;
    },
    decode(input: _m0.Reader | Uint8Array, length?: number): Asset {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAsset();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.type = reader.int32() as any;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial<I extends Exact<DeepPartial<Asset>, I>>(object: I): Asset {
        const message = createBaseAsset();
        message.id = object.id ?? "";
        message.type = object.type ?? 0;
        return message;
    },
};
type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;
export type DeepPartial<T> = T extends Builtin ? T : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>> : T extends {} ? {
    [K in keyof T]?: DeepPartial<T[K]>;
} : Partial<T>;
type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P : P & {
    [K in keyof P]: Exact<P[K], I[K]>;
} & Record<Exclude<keyof I, KeysOfUnion<P>>, never>;
if (_m0.util.Long !== Long) {
    _m0.util.Long = Long as any;
    _m0.configure();
}
